import React from "react";
import { Container, Row } from "react-bootstrap";
import useAllProjects from "../../hooks/useAllProjects";
import HomeProjectCard from "../Home/Home/HomeProjectCard/HomeProjectCard";
import style from "./Projects.module.css";

const Projects = () => {
  const [projects, loading] = useAllProjects();

  if(loading){
    return <h3>Loading...</h3>
  }

  return (
    <div className={style.project__container}>
        <h1>MY ALL <span className={style.colored}>PROJECTS</span> </h1>
        <div className={style.project__card}>
          <Row className="g-4">
            {projects.map((project) => (
              <HomeProjectCard
                key={project.id}
                project={project}
              ></HomeProjectCard>
            ))}
          </Row>
        </div>
    </div>
  );
};

export default Projects;
